import { Box, Button, Img, useColorMode } from '@chakra-ui/react'
import React from 'react'
import '../Styles/About.css'
const About = () => {
  const mode = useColorMode()
  const theme = mode.colorMode
  console.log(mode.colorMode)
  return (
  <>
    <Box className="about_mainContainer">
     <Box className='about_item'>
     <Box className="summary_item">
     <h1 > <strong id="About_banner"><strong  style={{fontSize:"60px",color:"rgb(225, 51, 51)"}}>A</strong>bout Me</strong></h1>
     <h1>➡️  I am a very passionate web developer .</h1>
     <h1>➡️ Currently going through the intensive journey of masai school.</h1>
     <h1>➡️ Have an experience of 1000+ hours of coding and 300+ hours of data sturctures and algorithms.</h1>
     <h1>➡️ I like collaborating in the projects which includes a team.</h1>
     <h1>➡️ My leisure interests include listening music and cooking.</h1>
     </Box>
     <Box className="profile"></Box>
     </Box>
    </Box>
    <Box className="extra_info" display={"none"}>
    {theme==="dark"? <Button bg="black" color="white"><a href='./Aniket_Bansal_Resume.pdf' target="_blank" rel='nonreferrer' download>Resume &nbsp; ✍️</a></Button>:<Button bg="white" color="black " border="1px solid grey"> <a Resume href='./Aniket_Bansal_Resume.pdf' target="_blank" rel='nonreferrer' download>Resume &nbsp; ✍️</a></Button> } 
      
    {theme==="dark"? <Button bg="black" color="white">aniketbansaldev@gmail.com 📧 </Button>: <Button bg="white" color="black " border="1px solid grey">aniketbansaldev@gmail.com 📧 </Button>}
   
    {theme==="dark"? <Button bg="black" color="white">+91 9958855047 📱</Button>: <Button bg="white" color="black " border="1px solid grey">+91 9958855047 📱 </Button>}

    {theme==="dark"? <Button bg="black" color="white">Delhi,India 📍</Button>: <Button bg="white" color="black " border="1px solid grey">Delhi,India 📍 </Button>}
    </Box>
    </>
  )
}

export default About